import { PatientHistoryType } from 'src/graphql.generated'
import { standardCategoryIcon } from '../../components/standardCategoryIcon'

const QUESTIONNAIRE = 'HEALTH_QUESTIONNAIRE'
// Standard's assessment document, which it draws for a setup step too.
const WRITTEN_RECORD = 'SETUP'
// Standard's phone handset, which it draws for a scheduled call.
const CALL = 'VIDEO_CALL_SCHEDULED'

// Standard has no icon per history type: a type it shows keeps that item's icon, a written record or a call
// takes the nearest one, and anything else gets its default.
const STANDARD_CATEGORY_FOR_TYPE: Partial<Record<PatientHistoryType, string>> = {
  [PatientHistoryType.Asrm]: QUESTIONNAIRE,
  [PatientHistoryType.Brs]: QUESTIONNAIRE,
  [PatientHistoryType.Burnout]: QUESTIONNAIRE,
  [PatientHistoryType.Gad7]: QUESTIONNAIRE,
  [PatientHistoryType.Isi]: QUESTIONNAIRE,
  [PatientHistoryType.Ocir]: QUESTIONNAIRE,
  [PatientHistoryType.Pcl5]: QUESTIONNAIRE,
  [PatientHistoryType.Phq9]: QUESTIONNAIRE,
  [PatientHistoryType.Pss4]: QUESTIONNAIRE,
  [PatientHistoryType.Who5]: QUESTIONNAIRE,
  [PatientHistoryType.Wpai]: QUESTIONNAIRE,

  [PatientHistoryType.LabOrder]: 'LAB_ORDER',
  [PatientHistoryType.LabOrderNote]: 'LAB_ORDER',

  [PatientHistoryType.VideoCall]: CALL,
  [PatientHistoryType.PhoneCall]: CALL,
  [PatientHistoryType.CheckInCall]: CALL,
  [PatientHistoryType.MissedIntakeCall]: CALL,

  [PatientHistoryType.IntakeNote]: WRITTEN_RECORD,
  [PatientHistoryType.IntakeNoteCoaching]: WRITTEN_RECORD,
  [PatientHistoryType.IntakeNoteComprehensive]: WRITTEN_RECORD,
  [PatientHistoryType.IntakeNotePsychiatry]: WRITTEN_RECORD,
  [PatientHistoryType.TreatmentPlan]: WRITTEN_RECORD,
  [PatientHistoryType.TreatmentPlanComprehensive]: WRITTEN_RECORD,
  [PatientHistoryType.TreatmentPlanComprehensiveUpdate]: WRITTEN_RECORD,
  [PatientHistoryType.Note]: WRITTEN_RECORD,
  [PatientHistoryType.AnonymousNote]: WRITTEN_RECORD,
  [PatientHistoryType.MonthlySummaryNote]: WRITTEN_RECORD,
  [PatientHistoryType.DischargeSummaryNote]: WRITTEN_RECORD,
  [PatientHistoryType.AdvancedFollowUpNote]: WRITTEN_RECORD,
  [PatientHistoryType.Custom]: WRITTEN_RECORD,
}

export const iconForHistoryType = (type: PatientHistoryType | null | undefined): string =>
  standardCategoryIcon((type && STANDARD_CATEGORY_FOR_TYPE[type]) || 'DEFAULT')
